// extracted by mini-css-extract-plugin
export default {"title":"ChartComponent_title__hDmG6"};